import React, { useState, useEffect, useMemo } from 'react'
import lodash from 'lodash'
import styled from 'styled-components'

import { Row, Col } from '../../../../1stlog-ui/src/components/Bootstrap'

const Wrapper = styled.div``

const Details = (props) => {
  const { order } = props

  const items = useMemo(() => {
    const result = []
    const { freightReferenceText } = order
    if (freightReferenceText) {
      result.push({
        label: i18n.t('return_reason', 'Retourengrund'),
        value: freightReferenceText,
      })
    }
    // result.push({ label: "Test", value: "Guten Tag" })
    return result
  }, [order])

  if (lodash.isEmpty(items)) {
    return null
  }

  return (
    <Wrapper>
      <Row className="mt-2">
        <Col>
          <h4>{i18n.t('shipment_details', 'Details')}</h4>
          <div className="d-inline-block">
            <table className="borderless mb-0 table table-xs">
              <tbody>
                {lodash.map(items, (item) => (
                  <tr>
                    <td className="text-muted">{item.label}</td>
                    <td>{item.value}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </Col>
      </Row>
    </Wrapper>
  )
}

export default Details
